import React from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'

// import css from './styles.js'
import {
  _DividerWrap, _Divider, _DividerIcon, _DividerTitle,
} from './styles'


const SearchTitleItem = ({ title, icon, className = '' }) => (
  <_DividerWrap className={className}>
    <_Divider>
      <_DividerIcon>
        {
          icon && <SvgIcon name={icon} width={'18'} height={'18'} />
        }
      </_DividerIcon>
      <_DividerTitle hasIcon={!!(icon)}>
        <strong>{title}</strong>
      </_DividerTitle>
    </_Divider>
  </_DividerWrap>
)

SearchTitleItem.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default SearchTitleItem
